var _rect, _rect2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEs = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 20,
  rx: 2,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "ES_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 28,
  height: 20
}, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 20,
  rx: 2,
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ES_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 5.333h28V0H0v5.333ZM0 20h28v-5.333H0V20Z",
  fill: "#DD172C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 14.667h28V5.333H0v9.334Z",
  fill: "#FFD133"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.333 9.333h1.334V10H7.333v-.667Z",
  fill: "#FFEDB1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.059 9.361A.333.333 0 0 1 6.391 9h1.884c.195 0 .349.167.333.361l-.172 2.055a1 1 0 0 1-.996.917h-.213a1 1 0 0 1-.997-.917L6.06 9.361Z",
  stroke: "#A41517",
  strokeWidth: 0.667
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 10h2.667v.667H8L7.333 12l-.666-1.333H6V10Z",
  fill: "#A41517"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 8,
  width: 1.333,
  height: 4.667,
  rx: 0.667,
  fill: "#A41517"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.333,
  y: 8,
  width: 1.333,
  height: 4.667,
  rx: 0.667,
  fill: "#A41517"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 7.733c0-.589.478-1.066 1.067-1.066H7.6c.59 0 1.067.477 1.067 1.066 0 .148-.12.267-.267.267H6.267A.267.267 0 0 1 6 7.733Z",
  fill: "#A41517"
}))));

export default SvgEs;